import React from 'react'
import {Outlet, useLocation} from "react-router";
import {useToast} from "../ui/toast";

export const AppLayout = props => {
  const location = useLocation()
  const {toast} = useToast();

  React.useEffect(() => {
    if (!location?.state?.toast) return

    toast(location.state.toast)
  }, [location?.state?.toast])

  return <>
    <div className="mx-auto w-full h-full overflow-y-scroll">
      <Outlet/>
    </div>
  </>
}